module.exports = __webpack_public_path__ + "img/quizz.74cace45.png";